import React from 'react';
import LandingDefault from './landing_default';

class Landing extends React.Component {

  render() {
    return (
      <LandingDefault />
    );
  }
}

export default Landing;
